import configureMeasurements, {
  acceleration,
  AllMeasures,
  AllMeasuresSystems,
  AllMeasuresUnits,
  apparentPower,
  area,
  charge,
  current,
  digital,
  each,
  force,
  frequency,
  illuminance,
  mass,
  pace,
  partsPer,
  pieces,
  length,
  power,
  pressure,
  reactiveEnergy,
  reactivePower,
  speed,
  time,
  voltage, volumeFlowRate
} from 'convert-units';
import newEnergy from "../model/custom/conversors/customEnergy";
import newTemperature from "../model/custom/conversors/customTemperature";
import newAngle from "../model/custom/conversors/customAngle";
import newVolume from "../model/custom/conversors/customVolume";
import {Injectable} from "@angular/core";

@Injectable({
  providedIn: 'root'
})

export class ConversorsService {
  public convert = configureMeasurements<AllMeasures, AllMeasuresSystems, AllMeasuresUnits>({
    acceleration,
    angle: newAngle,
    apparentPower,
    area,
    charge,
    current,
    digital,
    each,
    energy: newEnergy,
    force,
    frequency,
    illuminance,
    length,
    mass,
    pace,
    partsPer,
    pieces,
    power,
    pressure,
    reactiveEnergy,
    reactivePower,
    speed,
    temperature: newTemperature,
    time,
    voltage,
    volume: newVolume,
    volumeFlowRate});
}
